
export default {
  props: {
    bodyPadding: {
      type: String,
      default: '1rem',
    },
  },
};
